import Swiper from 'swiper'
import listing from './listing'
import Sorting from './sorting'
import struct from '../components/filter/struct'
import helpers from '../components/filter/helpers'
import mapHelper from '../components/filter/map-helper'

const Filter = new Vue({
    el: document.querySelector('.filters'),

    data: {
        struct,
        helpers,
        slide: 0,
        mapHelper,
        swiper: null,
        founded: false,
        headers: ['Фильтры'],
        Sorting: new Sorting,
        isMobile: $app.isMobile
    },

    methods: {
        next(target, runEvent = true) {
            this.slide++
            this.headers[this.slide] = target.textContent.trim()

            if (runEvent) $app.runEvent('filter', this.header)

            let name = target.getAttribute('href').replace('#', '')

            this.swiper.slideNext()

            if (this.slide === 2) {
                this.activeSlide.querySelector(`.filter[data-name="${name}"]`).classList.remove('d-none')
                this.helpers.processLimited(this.activeSlide)
            }
        },

        prev() {
            this.slide--
            this.hideFilters()
            this.swiper.slidePrev()

            return this.slide
        },

        hideFilters() {
            this.swiper.slides[this.swiper.slides.length-1].querySelectorAll('.filter:not(.d-none)').forEach(el => el.classList.add('d-none'))
        },

        processRequest(filter = {}, method = 'pushState', page = this.getPage(), fromShowMore = false) {
            this.startLoading()

            return $.get(page, filter, json => {
                if (method !== false) {
                    history[method](
                        { page, filter: json.filter },
                        'GDEBAR - Поиск и бесплатный подбор заведений',
                        page + (json.filter ? '?' + json.filter : '')
                    )
                }

                let founded = document.getElementById('catalog-view')

                founded.innerHTML = json.founded
                document.getElementById('paginator-next-url').innerHTML = json.paginatorNextUrl

                if (fromShowMore) {
                    $listing.$el.lastElementChild.insertAdjacentHTML('afterend', json.barList)
                    $listing.last.nextElementSibling.scrollIntoView({ behavior: 'smooth' })
                } else {
                    $listing.$el.innerHTML = json.barList
                    this.scrollTop()
                }

                $listing = listing()

                if (this.isMobile) {
                    this.founded = true
                    this.$refs.btnFounded.textContent = founded.textContent.replace('Найдено', 'Показать')
                }

                this.stopLoading()
            })
        },

        getData() {
            let form = new FormData(this.$el), data = {}

            for (let [name, val] of form.entries()) {
                if (name && val !== '0' && val.trim() !== '' && val !== 'null') {
                    let all = form.getAll(name)

                    data[name] = all.length === 1 ? all[0] : all
                }
            }

            return data
        },

        getPage() {
            return $app.urlPrefix + '/' + (location.pathname.endsWith('/specials') ? 'specials' : 'luchshie-zavedeniya')
        },

        submit() {
            if (['/', '/spb'].indexOf(location.pathname) >= 0) {
                location.href = $app.urlPrefix + '/luchshie-zavedeniya?' + $.param(this.getData())
            } else {
                return this.processRequest(this.getData()).then(() => {
                    if (this.slide && this.prev()) {
                        this.prev()
                    }
                })
            }
        },

        startLoading() {
            document.body.classList.add('loading', 'loading--full')
        },

        stopLoading() {
            document.body.classList.remove('loading', 'loading--full')
        },

        scrollTop() {
            (document.querySelector('h1') || $listing.$el)?.scrollIntoView({ behavior: 'smooth' })
        },

        setFeatures() { //кладём в особенности только те, которых нет в разделе Кухня
            this.struct[3].list.unshift(...JSON.parse(this.$el.dataset.features).reduce((result, feature) => {
                if (this.struct[1].list.find(item => item.name === name) === undefined) {
                    result.push({
                        title: feature.name,
                        name: feature.filter_name,
                        is_simple: feature.is_extended === '0'
                    })
                }

                return result
            }, []))
        },

        setSpecials() {
            let specials = JSON.parse(this.$el.dataset.specials)

            if (specials.length > 0) {
                this.struct.push({
                    title: 'Скидки и акции',
                    list: specials.map(spec => {
                        return {
                            id: spec.id,
                            title: spec.name,
                            is_simple: spec.id != 17,
                            name: `special[${spec.id}]`
                        }
                    })
                })
            }
        },

        setNewYear() {
            let src = JSON.parse(this.$el.dataset.newYear || null)

            if (src) {
                let list = []

                for (let [id, item] of Object.entries(src)) {
                    list.push({
                        name: id,
                        title: item.name
                    })
                }

                this.struct.push({ list, title: 'Новый год' })
            }
        },

        bindEvents() {
            Array.from(this.$el.elements).forEach(el => {
                el.addEventListener('change', () => {
                    let val = el.value,
                        getCapt = el => {
                            let capt = el.dataset.event || el.closest('.filter__main,.filter__item,.select')?.previousElementSibling?.textContent,
                                prefix = el.previousElementSibling?.classList?.contains('text-medium') ? el.previousElementSibling.textContent : ''

                            return (capt && capt !== this.header ? capt + ' ' + prefix : prefix).trim()
                        }

                    if (val && el.name) {
                        switch (el.type) {
                            case 'checkbox':
                                if (el.checked) {
                                    let capt = getCapt(el),
                                        label = el.nextElementSibling.nextElementSibling.textContent.trim()

                                    val = capt && capt !== 'undefined' ? { [capt]: label } : label
                                } else {
                                    val = null
                                }
                                break
                            case 'select-one':
                                val = { [getCapt(el)]: el.querySelector(`option[value="${val}"]`).textContent.trim() }
                                break
                            case 'select-multiple':
                                let capt = getCapt(el),
                                    value = [...el.options].filter(option => option.selected).map(option => option.textContent.trim()).join(', ')

                                val = capt ? { [capt]: value } : value
                                break
                            case 'radio':
                                val = { [el.parentNode.parentNode.previousElementSibling.textContent.trim()]: el.nextElementSibling.textContent.trim() }
                                break
                            default:
                                val = { [getCapt(el)]: val }
                                break
                        }

                        if (val) {
                            let params = this.slide === 2 ? { [this.headers[this.slide - 1]]: { [this.header]: val } } : (this.step ? { [this.header]: val } : val)

                            $app.runEvent('filter', params)
                        }
                    }
                })
            })
        },

        show(event) {
            event.preventDefault()

            if (this.$el) {
                this.$el.classList.remove('d-none')
                this.$el.classList.add('filters--active')

                $.fancybox.open({
                    modal: true,
                    type: 'html',
                    src: this.$el.parentNode,
                    afterShow: () => this.$el.dispatchEvent(new Event('filter.shown'))
                })
            } else {
                this.startLoading()

                $.get($app.urlPrefix + '/bar/search/loadFilter', json => {
                    $.fancybox.open({
                        modal: true,
                        type: 'html',
                        src: json.filter,
                        afterShow: instance => {
                            Filter.$mount(instance.current.$content[0].querySelector('form'))

                            this.stopLoading()
                        }
                    })
                })
            }

            return false
        },

        close () {
            this.founded = false
            $.fancybox.getInstance().close()
            this.$el.classList.add('d-none')
            this.$el.classList.remove('filters--active')
        }
    },

    computed: {
        activeSlide() {
            return this.swiper.slides[this.swiper.activeIndex]
        },

        secondLevel() {
            return this.struct.find(item => item.title === this.header)?.list
        },

        header() {
            return this.headers[this.slide]
        }
    },

    mounted() {
        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            spaceBetween: 0,
            autoHeight: true,
            allowTouchMove: false
        })

        this.setFeatures()
        this.setSpecials()
        this.setNewYear()

        $('.select2', this.swiper.slides[2]).select2().on('select2:select', event => {
            event.target.dispatchEvent(new Event('change'))
        })

        this.Sorting.bind()

        history.pushState(
            { page: location.pathname, filter: location.search.split('?')[0] },
            document.title,
            location.href
        )

        window.addEventListener('popstate', ({ state }) => {
            if (state) {
                location.href = state.page + (state.filter ? '?' + state.filter : '')
            }
        })

        this.$el.addEventListener('change', () => this.founded = false)

        if (! this.isMobile) {
            this.$el.classList.remove('d-none')
        }

        this.$el.previousElementSibling.classList.add('d-none')

        this.bindEvents()

        if (location.pathname.indexOf('/blyuda') >= 0) {
            let goToDishFilter = (duration = 2500) => {
                this.next(this.$el.querySelector('a[href="#Кухня | Блюда и напитки"]'), false)

                setTimeout(() => this.next(this.$el.querySelector('a[href="#food[]"]'), false), duration)
            }

            if ($app.isMobile) {
                this.$el.addEventListener('filter.shown', () => goToDishFilter(500))
            } else {
                goToDishFilter()
            }
        }
    },

    components: {
        swiperSlide: require('../components/filter/swiper-slide').default
    }
})

export default Filter